const formRendererModule = {
  id: "211b9aa1-6828-4004-8c8d-287e00504f53",
  key: "module-application-form",
  config: {
    general: {},
  },
};

export default formRendererModule;
